module.exports = __webpack_public_path__ + "static/img/yiliao_hangye.88b01422.png";